import ajax from "../../authenticationSafeAjax";
import { timeHorizonToValidityPeriod } from "../common/validityPeriodMigration";

export const ERRORS = {
    UNAUTHENTICATED: "User Not Authenticated",
    FORBIDDEN: "Recommendation Not Sent To User",
    NOT_FOUND: "Recommendation Not Found",
    UNKNOWN: "Unknown"
};

export default function(recommendationId, callback) {
    ajax({ url: `/disclosure/api/disclosures/` + recommendationId,
           headers: { "Accept": "application/json" }
         },
        (code, text) => {

            switch (code) {
                case 200:
                    const responseData = migrateTimeHorizonToValidityPeriod(JSON.parse(text));
                    callback({ success: responseData, error: null });
                    break;
                case 400:
                    callback({ success: null, error: ERRORS.UNAUTHENTICATED });
                    break;
                case 403:
                    callback({ success: null, error: ERRORS.FORBIDDEN });
                    break;
                case 404:
                    callback({ success: null, error: ERRORS.NOT_FOUND });
                    break;
                default:
                    callback({ success: null, error: ERRORS.UNKNOWN });
            }
        }
    );
}

function migrateTimeHorizonToValidityPeriod(disclosure) {
    function migrate(history) {
        return history.map(item => timeHorizonToValidityPeriod(item));
    }

    disclosure.history = migrate(disclosure.history);
    disclosure.changeHistory = migrate(disclosure.changeHistory);

    return disclosure;
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/actions/fetchDisclosureDataFromServer.js
 **/